module.exports = __webpack_public_path__ + "img/SynesisOne-Logo.95f14012.svg";